export default "__VITE_ASSET__CBE0cVp1__"